export function euclideanDistance(
  x1: number,
  y1: number,
  x2: number,
  y2: number,
): number {
  const dx = x2 - x1;
  const dy = y2 - y1;
  return Math.sqrt(dx * dx + dy * dy);
}

/** Chebyshev distance: ideal for an 8-direction grid. */
export function chebyshevDistance(
  x1: number,
  y1: number,
  x2: number,
  y2: number,
): number {
  return Math.max(Math.abs(x2 - x1), Math.abs(y2 - y1));
}

export function manhattanDistance(
  x1: number,
  y1: number,
  x2: number,
  y2: number,
): number {
  return Math.abs(x2 - x1) + Math.abs(y2 - y1);
}
